module.exports = __webpack_public_path__ + "img/folder-icon-purple.809e8b95.svg";